import {
  Localizations
} from 'localize'

Localizations.append({
  modules: {
    cart: {
      components: {
        discount: {
          remove: 'remove',
          valid: '{0} off',
          freeShipping: 'Free shipping',
          errors: {
            application: 'There was an error applying the discount',
            only1FreeShipping: 'Only 1 free shipping discount can be applied for checkout',
            only1PriceDiscount: 'Only 1 price discount can be applied for checkout'
          }
        }
      }
    }
  }
})
